module.exports = __webpack_public_path__ + "img/1 (4).fb82702c.jpg";